import React from "react";
import { RichTextDisplay } from "@/components/ui/rich-text-display";
import { ContentBlock } from "@/types/case-study";

interface TextBlockProps {
  block: ContentBlock;
}

export const TextBlock: React.FC<TextBlockProps> = ({ block }) => {
  return (
    <div className="prose prose-lg max-w-none text-gray-700 [&_ul]:space-y-2 [&_ol]:space-y-2 [&_li]:leading-relaxed [&_li_p]:my-0 [&_li_p]:mt-0 [&_li_p]:mb-0 [&_p]:text-sm">
      <RichTextDisplay content={block.content || ""} />
    </div>
  );
};